import { render, staticRenderFns } from "./formAtendimento.vue?vue&type=template&id=9dbcaaec&scoped=true"
import script from "./formAtendimento.vue?vue&type=script&lang=js"
export * from "./formAtendimento.vue?vue&type=script&lang=js"
import style0 from "./formAtendimento.vue?vue&type=style&index=0&id=9dbcaaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbcaaec",
  null
  
)

export default component.exports